import { PropTypes } from 'prop-types';
import { ReactComponent as Spin } from './ajax-loader.svg';

const AccionaSimpleSpinner = ({ size }) => {
  return <Spin height={size} width={size} alt="Loading"></Spin>;
};

AccionaSimpleSpinner.propTypes = {
  size: PropTypes.number,
};

AccionaSimpleSpinner.defaultProps = {
  size: 64,
};

export default AccionaSimpleSpinner;
